export function doAsync(func: () => void, deadline = 50): () => void {
  if (process.browser && window.requestIdleCallback) {
    const timer = window.requestIdleCallback(func, {timeout: deadline});
    return () => {
      window.cancelIdleCallback(timer);
    };
  } else {
    const timer = setTimeout(func, deadline);
    return () => {
      clearTimeout(timer);
    };
  }
}
